import { render, staticRenderFns } from "./PensionUnitSelectionNew.vue?vue&type=template&id=278ac8f6&scoped=true&"
import script from "./PensionUnitSelectionNew.vue?vue&type=script&lang=ts&"
export * from "./PensionUnitSelectionNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ac8f6",
  null
  
)

export default component.exports